<template>
  <div>
    <div id="coaching" style="max-width: 1100px;margin: 0 auto;">
      <h1>Keep connected with virtual meet-ups and one-to-one coaching</h1>
      <p>Join weekly virtual meetups and stay connected with coaches and friends from around the globe.</p>
      <p class="marginBottom">We currently host 2 meet-ups each week, with one-to-one time <a href="https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching">available for purchase from our shop</a>.</p>
      <div class="coachingCards">
        <mu-row gutter>
          <mu-col width="100" tablet="100" desktop="50">
            <coaching-card
              style="min-height: 540px;"
              image="https://res.cloudinary.com/grohealth/image/upload/v1610543180/Low%20Carb%20Program/UI-Assets/5fd1e9e75ac081c56b819597_evening-meetups-p-500.webp"
              title="Monday night meet up"
              text="Join our original Monday night meet up, hosted by our very own Health coaches. This meet up has been long-standing and is ideal for those who have been attending the meet ups for some time. It’s a great way to kickstart your week on a positive note and keep you feeling motivated. The Health coaches will be speaking to you about a different topic each week, followed by a good old catch up with your fellow members."
              :list="['Get support from your mentors', 'Meet others on the same journey']"
              buttonText="More about Monday meet ups"
              buttonLink="life/low-carb-programs-virtual-meet-up-monday-6pm"
            />
          </mu-col>
          <mu-col width="100" tablet="100" desktop="50">
            <coaching-card
              image="static/weighin.png"
              title="Wednesday Meet ups"
              text="If you are new to the Low Carb Program, then this is a must do meet up for you! On this meet up you can expect to hear your mentor cover topics for beginners, who are new to the program and low carb approach. It is also a great way to ask questions and meet with other members at a similar point of their journey to you."
              :list="['Get support from your mentors', 'Something else']"
              buttonText="More about Wednesday meet ups"
              buttonLink="life/low-carb-newbie-meet-up-wednesday-6pm"
            />

          </mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="100" desktop="50">
            <coaching-card
              image="https://res.cloudinary.com/grohealth/image/upload/v1612266366/Low%20Carb%20Program/UI-Assets/601907ca6ba8ee0341514d3a_antonia-remote-p-500.webp"
              title="Low Carb Program daily drop in sessions"
              text="You can drop in and visit us at 11am any day of the working week. This is a great session to use if you are new to the Low Carb Program, unsure of where to get started or looking for some help on how to use the various features available."
              :list="['A chance to ask questions', 'Find support and motivation every day']"
              buttonText="More about Daily Drop-in Sessions"
              buttonLink="life/january-bootcamp-drop-in-sessions"
            />
          </mu-col>
        </mu-row>

      </div>
      <div class="supportCard">
        <mu-row>
          <mu-col width="100" tablet="50" desktop="50">
          </mu-col>
          <mu-col width="100" tablet="50" desktop="50">
            <div class="supportInfo">
              <h2>Need some one-to-one support?</h2>
              <p>If you feel like you could do with some more personal support, or just prefer some privacy, then one-to-one coaching is for you.</p>
              <ul>
                <li>Meet your personal health coach and mentor.</li>
                <li>Get help on how to make the most out of the Program.</li>
                <li>Create short and long-term goals to better your health.</li>
                <li>Receive support on how to tailor the low carb lifestyle for you.</li>
              </ul>
              <mu-flat-button
                class="button"
                label="Purchase one-to-one coaching"
                href="https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
              />
            </div>
          </mu-col>
        </mu-row>
      </div>
      <div class="stepsCard">
        <h2>How it works</h2>
        <p>Follow these three simple steps to book in with your health coach and start your journey to better health today.</p>
        <div class="stepList">
          <div class="step">
            <div class="stepNumber">1</div>
            <div class="stepText">
              <p>Purchase your Health Coaching session from the Low Carb Program Shop.</p>
            </div>
          </div>
          <div class="step">
            <div class="stepNumber">2</div>
            <div class="stepText">
              <p>Use the link in the receipt email to book a coaching session with a coach of your choice. Choose the date and time to suit you.</p>
            </div>
          </div>
          <div class="step">
            <div class="stepNumber">3</div>
            <div class="stepText">
              <p>Join the 30-minute session using your phone or computer using Zoom.</p>
            </div>
          </div>
        </div>
        <mu-flat-button
          class="button"
          label="Purchase one-to-one coaching"
          href="https://shop.lowcarbprogram.com/collections/frontpage/products/1-1-health-coaching"
        />
      </div>
    </div>
  </div>
</template>

<script>
import './Coaching.less';
import CoachingCard from '../../components/CoachingCard/CoachingCard.vue'

export default {
  components: {
    CoachingCard
  },
  name: 'coaching',
  data () {
    return {
    }
  },
  methods: {
    goToArticle(path) {
      let self = this;
      self.$router.push({
        path: path
      })
    }
  },
  computed: {

  },
  mounted () {
    let self = this;

  },
}
</script>



// WEBPACK FOOTER //
// Coaching.vue?04395b05